import usePermissionsDomain from 'common/hooks/settings/usePermissionsDomain';
import useCustomizationOptions from 'components/hooks/useCustomizationOptions';
import first from 'lodash/first';
import { useEffect, useState } from 'react';
import useDevCoachingModule from './useDevCoachingModule';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';

const useRoleBasedModules = ({ userConfig = {} } = {}) => {
  const { selectedAccounts } = userConfig;
  const loggedInAccount = useSelector(myAccountSelector);
  const account = selectedAccounts ? first(selectedAccounts) : loggedInAccount;
  const isAccountAdmin = userConfig.isAdmin ?? isAdmin(account);
  const isAccountSuperUser = isSuperUser(account);

  const { data: permissions, isLoading } = usePermissionsDomain();
  const [userPermissionDomainIds, setUserPermissionDomainIds] = useState(
    account?.permission_ids ?? []
  );

  const customizationOptions = useCustomizationOptions({
    selectedTeamId: null
  });

  useEffect(() => {
    setUserPermissionDomainIds(account?.permission_ids ?? []);
  }, [account]);

  const addPermissionDomainId = id => {
    if (userPermissionDomainIds.includes(id)) {
      return;
    }
    setUserPermissionDomainIds([...userPermissionDomainIds, id]);
  };

  const removePermissionsDomainIds = ids => {
    setUserPermissionDomainIds(
      userPermissionDomainIds.filter(permission => !ids.includes(permission))
    );
  };

  const devCoaching = useDevCoachingModule({
    permissions,
    customizationOptions,
    userConfig: { isAdmin: isAccountAdmin, isSuperUser: isAccountSuperUser },
    userPermissionDomainIds,
    removePermissionsDomainIds,
    addPermissionDomainId
  });

  return {
    userPermissionDomainIds,
    showRoleBasedModules: !isLoading && devCoaching.showDevCoachingToggle,
    devCoaching
  };
};

export default useRoleBasedModules;
